module.exports = __webpack_public_path__ + "static/media/PDF-03.39f06383.webp";